import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=80e6eec0&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/login-reg.css?vue&type=style&index=0&id=80e6eec0&prod&scoped=true&lang=css&external"
import style1 from "./Login.vue?vue&type=style&index=1&id=80e6eec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e6eec0",
  null
  
)

export default component.exports